import {Component, computed, input} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {BillingTimesheetState} from '../../../api';

@Component({
  selector: 'elcia-timesheet-state-badge',
  imports: [TranslatePipe],
  templateUrl: './timesheet-state-badge.html',
  styleUrl: './timesheet-state-badge.scss',
  host: {class: 'inline-flex'},
})
export class TimesheetStateBadge {
  state = input.required<BillingTimesheetState>();

  protected readonly badgeClass = computed(() => {
    switch (this.state()) {
      case BillingTimesheetState.VALID:
        return 'bg-green-100 text-green-700';
      case BillingTimesheetState.LINKEDTOINVOICE:
        return 'bg-blue-100 text-blue-700';
      case BillingTimesheetState.BILLED:
        return 'bg-purple-100 text-purple-700';
      default:
        return 'bg-[var(--p-surface-200)] text-surface-600';
    }
  });
}
